export const DOT_OPERATOR = '⋅';

/**
 * иконка месяца
 */
export const MOON = String.fromCharCode(9790);
export const SLASH = String.fromCharCode(47);
